import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 16.789"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.234 16.789a1.932 1.932 0 0 1-1.31-.5L.542 10.424a1.609 1.609 0 0 1 0-2.408 1.967 1.967 0 0 1 2.618 0l5.072 4.661L16.838.497a1.967 1.967 0 0 1 2.618 0 1.608 1.608 0 0 1 0 2.409L9.541 16.289a1.931 1.931 0 0 1-1.307.5Z"
    }, null, -1)
  ])))
}
export default { render: render }